import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import Home from "./pages/Home";
import Question from "./pages/Question";
import Answer from "./pages/Answer";
import Final from "./pages/Final";
import Comment from "./pages/Comment";
import Prior from "./pages/Prior";
import { publicPath } from "../vue.config";

const routes = [
  // {
  //     path: '*',
  //     component: NotFound
  // },

  {
    path: "/",
    component: Home,
  },
  {
    path: "/question/:quiz?",
    component: Question,
    name: "Question",
  },
  {
    path: "/prior/:quiz?",
    component: Prior,
    name: "Prior",
  },
  {
    path: "/answer/:truefalse",
    component: Answer,
    name: "Answer",
  },

  {
    path: "/final",
    component: Final,
    name: "Final",
  },
  {
    path: "/comment",
    component: Comment,
    name: "Comment",
  },
];

export default new VueRouter({
  mode: "history",
  base: publicPath,
  routes,
  linkActiveClass: "is-active",
});
